module.exports = __webpack_public_path__ + "61f35c72.png";